export default class ReactHookFormUtil {
    // Safe nested lookup for a bracketed RHF field name (e.g. "foo.bar[3].baz") against an
    // arbitrary nested object such as formState.errors - unlike getNestedFormValues below, this
    // short-circuits to undefined at the first missing segment instead of throwing, since an
    // errors object legitimately omits whole branches whenever nothing under them is invalid.
    static getNestedError(errors: { [x: string]: unknown; } | undefined, name: string | undefined) {
        if (!errors || !name) {
            return undefined;
        }
        const path = name.replace(/\[(\d+)\]/g, '.$1').split('.');
        return path.reduce((o: unknown, key: string) => (
            o != null ? (o as { [x: string]: unknown })[key] : undefined
        ), errors as unknown);
    }

    static getNestedFormValues(
        formValues: { [x: string]: unknown; },
        formPrefix: string
    ) {
        let target = formValues;
        let formArray = formPrefix.split('.');
        for (let sect of formArray) {
            let index = sect.indexOf('[');
            if (index > -1) {
                let parent = sect.slice(0, index);
                let i = sect.slice(index + 1, sect.length - 1);
                target = target[parent] as { [x: string]: unknown };
                if (!!target) {
                    target = target[i] as { [x: string]: unknown };
                } else {
                    return undefined;
                }
            } else {
                target = target[sect] as { [x: string]: unknown };
            }
        }
        return target;
    }
}



// WEBPACK FOOTER //
// ./src/util/ReactHookFormUtil.ts